/**
 * apiFetch — a drop-in replacement for fetch() with automatic 401 handling.
 *
 * When any API call returns 401 Unauthorized:
 *  1. localStorage user data is cleared.
 *  2. A custom "session-expired" event is dispatched (UserContext listens).
 *  3. The page is redirected to /?openLogin=true with a session-expired flag.
 *
 * Usage: apiFetch("/api/some-endpoint", { method: "POST", body: ... })
 *        Same signature as window.fetch().
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export async function apiFetch(url, options = {}) {
  // Always send cookies for cross-origin auth
  const mergedOptions = {
    credentials: "include",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  };

  // Resolve relative URLs against the backend base
  const resolvedUrl = url.startsWith("http") ? url : `${BACKEND_URL}${url}`;

  const response = await fetch(resolvedUrl, mergedOptions);

  if (response.status === 401) {
    const msg = "⚠️ Your session has expired. Please sign in again.";

    // Clear all frontend auth state
    localStorage.removeItem("user");
    localStorage.removeItem("userType");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("scorecardAccess");
    localStorage.removeItem("scorecardtoken");
    localStorage.removeItem("postLoginRedirect");

    // Store message in sessionStorage — UserLogin + StudentLogin read this
    // and show it inside the login form where the user is looking
    sessionStorage.setItem("oauthLoginMessage_client", msg);
    sessionStorage.setItem("oauthLoginMessage_student", msg);

    // Tell UserContext to clear its state and show a toast
    window.dispatchEvent(new CustomEvent("session-expired"));

    // Also redirect immediately if we're not already on the home/login page
    const currentPath = window.location.pathname;
    const isPublicPage = currentPath === "/" || currentPath === "/login";
    if (!isPublicPage) {
      window.location.href = "/?openLogin=true&sessionExpired=true";
    }
  }

  return response;
}
